import { useAppSelector } from '@hooks/app/redux';
import { Button, Form, MessageBox } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';
import { Prompt, useHistory, useRouteMatch } from 'react-router-dom';
import { useTheme } from 'styled-components';
import BaseForm from './components/base-form';
import InstitutionForm from './components/institution-form';
import ServicesForm from './components/services-form';
import { validationSchema } from './CreateWorkspace.schema';
import { CreateWorkspaceSC } from './CreateWorkspace.styled';
import { useInitialValues, useSubmitHandler } from './CreateWorkspace.utils';

interface RouteParams {
  workspaceId?: string;
}

const CreateWorkspace: React.FunctionComponent = () => {
  const { goBack, replace, push } = useHistory();
  const providerId = useAppSelector((state) => state.users.currentProvider?.id);
  const isMounted = React.useRef(false);
  const theme = useTheme();
  const { params } = useRouteMatch<RouteParams>();
  const { formatMessage } = useIntl();

  React.useEffect(() => {
    if (isMounted.current) {
      replace('/business/profile/departments');
    }

    isMounted.current;
  }, [providerId]);

  const { initialValues, loading } = useInitialValues({ workspaceId: params.workspaceId });
  const { onSubmit } = useSubmitHandler();

  const [, formOptions] = Form.useForm({
    onSubmit,
    initialValues,
    validationSchema,
  });

  return (
    <CreateWorkspaceSC
      title={
        params.workspaceId
          ? initialValues.name
          : formatMessage({ id: 'routes.business_profile_departments_create-workspace' })
      }
      onBack={() => {
        goBack();
      }}
    >
      <Form {...formOptions} showFeedback={false} variant="on-light" enableReinitialize>
        <BaseForm />
        <InstitutionForm />
        <Form.Section
          label="Zamestnanci"
          extra={
            params.workspaceId ? (
              <Button
                variant="ghost"
                size="small"
                rightArrow
                onClick={() => {
                  push(`/business/profile/departments/staff/${params.workspaceId}`);
                }}
              >
                Upraviť
              </Button>
            ) : null
          }
        >
          <MessageBox
            caption="Spravovať zamestnancov môžete z prehľadu ambulancií"
            size="small"
            style={{ marginTop: theme.spacings.component.XXS }}
          />
        </Form.Section>
        <ServicesForm />
        <Form.Custom>
          {(f) => (
            <>
              <Prompt when={f.dirty} message="Máte neuložené zmeny, neozaj chcete odísť?" />
              <div style={{ textAlign: 'right', marginTop: theme.spacings.component.L }}>
                <Button type="submit" loading={f.isSubmitting || loading} block={false}>
                  {params.workspaceId ? 'Upraviť Pracovisko' : 'PRIDAŤ Pracovisko'}
                </Button>
              </div>
            </>
          )}
        </Form.Custom>
      </Form>
    </CreateWorkspaceSC>
  );
};

export default React.memo(CreateWorkspace);
